import React, { FC, useEffect, useState } from 'react';

import { getRolesListFetch } from 'src/resources/rolesList/reducer';
import { RootStoreType } from 'src/types/store';
import { useDispatch, useSelector } from 'react-redux';
import translate from '@translate';
import { setLocationParams } from 'src/resources/location/reducer';
import TableSimple from 'src/components/TableSimple';
import { allColumns } from './constants';
import { TableRowType } from 'src/types/table';
import LaunchIcon from '@mui/icons-material/Launch';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import { useCheckPermission } from 'src/utils/checkPermission';
import TopBlock from './TopBlock';

export interface RolesListContainerPropsType {}
const RolesListContainer: FC<RolesListContainerPropsType> = (props) => {
    const dispatch = useDispatch();

    const loading = useSelector((state: RootStoreType) => state.rolesList.loading);
    const rolesData = useSelector((state: RootStoreType) => state.rolesList.data);

    const [rolesList, setRolesList] = useState<TableRowType[]>([]);

    const permissionCreate = useCheckPermission('ROLE.CREATE');
    const permissionDeatil = useCheckPermission('ROLE.DETAIL');

    useEffect(() => {
        dispatch(setLocationParams({ name: translate('roles.title') }));
    }, []);

    useEffect(() => {
        if (!rolesData) {
            dispatch(getRolesListFetch());
        } else {
            setRolesList(
                rolesData.map((role) => ({
                    ID_ROLE: role.ID_ROLE,
                    ROLE_NAME: role.ROLE_NAME,
                    ROLE_INFO: role.ROLE_INFO,
                    countPermissions: role.permissions?.length || 0,
                }))
            );
        }
    }, [rolesData]);

    const reloadList = () => {
        dispatch(getRolesListFetch());
    };

    return (
        <>
            <TopBlock reloadList={reloadList} permissionCreate={permissionCreate} />
            <TableSimple
                rowIdKey="ID_ROLE"
                rows={rolesList}
                loading={loading}
                columsLabelPrefix="roles.table"
                allColumns={allColumns}
                initSort={{ column: 'ID_ROLE', direction: 'DESC' }}
                rowActions={[
                    {
                        icon: <LaunchIcon />,
                        label: translate('roles.action.roleDetail'),
                        getLink: (row) => `/admin/roles/${row.ID_ROLE}/`,
                        hiddenFce: () => !permissionDeatil,
                    },
                    {
                        icon: <SupervisedUserCircleIcon />,
                        label: translate('roles.action.roleApprovedDetail'),
                        getLink: (row) => `/admin/roles/${row.ID_ROLE}/approved/`,
                        hiddenFce: () => !permissionDeatil,
                    },
                ]}
                heightVariant="top-tab"
                fullHeight
                optionsSessionName="rolesTable"
            />
        </>
    );
};

export default RolesListContainer;
